import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class InitService {
  private baseUrl: string = environment.baseUrl;
  constructor(private httpClient: HttpClient) {}

  // getUser(userId: string): Observable<AccountInfo> {
  //   return this.httpClient.post<AccountInfo>(
  //     `${this.baseUrl}/api/v1/fms/AccountInfo`,
  //     {
  //       userId,
  //     }
  //   );
  // }
}
